module.exports = __webpack_public_path__ + "img/robux.82b25557.svg";